import type { Attachment } from '@/models/attachment';
import styles from '../AttachmentRail.module.css';

const dateFormatter = new Intl.DateTimeFormat('en-US', {
  month: 'short',
  day: 'numeric',
  year: 'numeric',
});

interface AttachmentItemProps {
  attachment: Attachment;
  isSelected: boolean;
  onSelect: (uuid: string) => void;
}

export default function AttachmentItem({
  attachment,
  isSelected,
  onSelect,
}: AttachmentItemProps) {
  const formattedDate = dateFormatter.format(new Date(attachment.createdAt));

  return (
    <button
      type="button"
      className={`${styles.item} ${isSelected ? styles.selected : ''}`}
      onClick={() => onSelect(attachment.uuid)}
    >
      <span className={styles.itemName}>{attachment.name}</span>
      <span className={styles.itemMeta}>
        {attachment.category} &middot; {formattedDate}
      </span>
    </button>
  );
}
